import { ArrowLeftIcon } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { useNavigate } from "react-router";
import { getTemplatesByCategory } from "@hicya/habits-shared/data";

import { HabitIcon } from "@/components/ui/habit-icon";

import styles from "./habit-templates.module.scss";

export function HabitTemplates() {
  const navigate = useNavigate();
  const categorized = getTemplatesByCategory();

  return (
    <div className={styles.page}>
      <div className={styles.topBar}>
        <button type="button" className={styles.back} onClick={() => navigate(-1)}>
          <ArrowLeftIcon size={20} aria-hidden="true" /> Back
        </button>
      </div>

      <h2 className={styles.heading}>Browse Templates</h2>

      {Array.from(categorized.entries()).map(([category, templates]) => (
        <div key={category} className={styles.category}>
          <h3 className={styles.categoryName}>{category}</h3>
          <div className={styles.grid}>
            {templates.map((template) => (
              <button
                key={template.id}
                type="button"
                className={styles.card}
                onClick={() => navigate(`/habits/new?template=${template.id}`)}
              >
                <span className={styles.icon}>
                  <HabitIcon value={template.icon} />
                </span>
                <span className={styles.name}>{template.name}</span>
                <span className={styles.desc}>{template.description}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
